<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "ComponentBadge",
  });

  const props = defineProps({
    icon: {
      type: String,
      default: null,
    },
    iconClass: {
      type: [String, Object, Array],
      default: null,
    },
  });

  const iconContainsBackground = computed(() => {
    if (!props.icon) {
      return false;
    }

    return [
      "info",
      "help",
      "stars",
      "circle_notifications",
      "outbound",
      "lightbulb_circle",
      "add_circle",
      "remove_circle",
      "change_circle",
    ].includes(props.icon);
  });
</script>

<template>
  <div class="relative inline-block">
    <slot />

    <div
      :class="
        cn(
          'absolute -top-1.5 -right-2 inline-flex items-center justify-center rounded-full font-medium',
          {
            'size-4 p-0 text-lg text-current': iconContainsBackground,
            'size-4 bg-current p-1 text-sm': !iconContainsBackground,
          },
          iconClass,
        )
      "
    >
      <span :class="{'text-white': !iconContainsBackground}">
        <slot name="icon">
          <component-icon class="fill-current">{{ icon }}</component-icon>
        </slot>
      </span>
    </div>
  </div>
</template>
